import { TranslateService } from '@ngx-translate/core';
import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'app-popup',
    templateUrl: './popup.component.html',
    styleUrls: ['./popup.component.scss'],
    standalone: false
})
export class PopupComponent {

  isFavorite: string;
  hasAlert: string;


  constructor(
    public dialogRef: MatDialogRef<PopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private readonly transalateService: TranslateService) {
    this.isFavorite = (data.isFavorite) ? this.transalateService.instant('edp.emarket.fast.quote.remover')
      : this.transalateService.instant('edp.emarket.fast.quote.adicionar');
    this.hasAlert = (data.hasAlert) ? this.transalateService.instant('edp.emarket.popup.definir.outro')
      : this.transalateService.instant('edp.emarket.popup.definir');
  }

}
